var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"primary mt-19",attrs:{"absolute":"","height":"auto"}},[_c('v-layout',{attrs:{"justify-center":"","row":"","wrap":""}},[_c('v-flex',{staticClass:"primary white--text",attrs:{"py-3":"","text-xs-center":"","xs12":""}},[_vm._v(" ©2021 — "),_c('strong',[_vm._v(" GharNaksha Software ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }